var render = function render(){var _vm=this,_c=_vm._self._c;return _c('toaster',{staticClass:"insight-feedback-sent-toaster",on:{"close-toaster":_vm.closeToaster},scopedSlots:_vm._u([{key:"text",fn:function(){return [_c('div',[_c('span',{staticClass:"bold"},[_vm._v("הפידבק נשלח.")]),_vm._v(" "),_c('span',[_vm._v("תודה!")])])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }